export default __webpack_public_path__ + "static/media/union-pay.7e5ea80b.png";